/**
 * 充电用户管理 接口
 */
import {
   deleteRequest,
   putRequest,
   getRequest,
   postRequest,
} from "../../utils/api";

export const apiListChargeUsers = (data) => {
   return postRequest('/api/charging-user/list?page=1&size=100', data)
}

export const apiUpdate = (data) => {
   return putRequest('/api/charging-user/update', data)
}

export const apiDelete = (data) => {
   return deleteRequest('/api/charging-user/delete'+id, data)
}
export const apiGet = (id) => {
   return getRequest('/api/charging-user/get/'+id)
}

export const apiListOrders = (data) => {
   return postRequest('/api/order/?page=1&size=100', data)
}

export const apiGetOrder = (id) => {
   return getRequest('/api/order/get/'+id)
}

export const apiListStations = (data) => {
   // data.page=1;
   // data.size=9999;
   return postRequest('/api/charge-station/list', data)
}

export const apiListEquipmentsByStationId = (data) => {
   return postRequest('/api/chargeEquipment/list', data)
}

export const apiListEquipments = (data) => {
   return postRequest('/api/chargeEquipment/list', data)
}
export const apiCreateCode = (code) => {
   return postRequest('/api/chargeEquipment/createQrcode/'+code)
}
export const apiListGatewayByStationId = (data) => {
   return postRequest('/api/charge-gateway/list?page=1&size=9999', data)
}

